const NutrientLoading = () => {
  const NutrientLoadingData = [
    {
      "Source": "Cherry Creek (CC-10)",
      "Phosphorus Mass (pounds)": Number(8662).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(61066).toLocaleString(),
    },
    {
      "Source": "Cottonwood Creek (CT-2)",
      "Phosphorus Mass (pounds)": Number(479).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(23682).toLocaleString(),
    },
    {
      "Source": "Alluvial Groundwater",
      "Phosphorus Mass (pounds)": Number(1364).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(2453).toLocaleString(),
    },
    {
      "Source": "Precipitation",
      "Phosphorus Mass (pounds)": Number(230).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(4579).toLocaleString(),
    },
    {
      "Source": "Total",
      "Phosphorus Mass (pounds)": Number(10735).toLocaleString(),
      "Nitrogen Mass (pounds)": Number(91780).toLocaleString(),
    }
  ];

   // Declare and configure request overview table
   const NutrientLoadingTable = new requestTable({
    container: "#nutrient-loading-table",
    filterEnabled: false,
    tableHeaders: {
      "Source": "Source",
      "Phosphorus Mass (pounds)": "Phosphorus Mass (pounds)",
      "Nitrogen Mass (pounds)": "Nitrogen Mass (pounds)",
    },
    tableActions: [],
    tableData: NutrientLoadingData,
  });
  NutrientLoadingTable.buildTable();
};
